import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import scrollToComponent from "react-scroll-to-component";
import {
  isElementVisibleOnDOM,
  isElementInViewPort
} from "../helpers/domHelpers";

class ScrollManager extends Component {
  // componentDidUpdate(prevProps) {
  //   /* when selected pax has changed, we want to react to this change.
  //    * onSelectedPaxChange is usually scrolling to "First Important View"
  //    */
  //   const { selectedPaxId } = this.props;
  //   const { selectedPaxId: prevSelectedPaxIndex } = prevProps;
  //   if (selectedPaxId !== prevSelectedPaxIndex) {
  //     // make sure we don't run this on EACH update!
  //     this.onSelectedPaxChange();
  //   }
  // }

  onChildMount = () => {
    /* this should be called when the children mount or updated
    *  meaning they should call it on componentDidMount / componentDidUpdate etc..
    */

    this.scrollToFirstImportantView();
  };

  _scrollToComponent = (ref, config) => {
    scrollToComponent(ref, config);
  };

  isElementTopIntoView = el => {
    let rect = el.getBoundingClientRect();
    let elemTop = rect.top;
    let isVisible = false;
    if (elemTop > 0) isVisible = true;
    return isVisible;
  };

  scrollToFirstImportantView = () => {
    const { isMobileView } = this.props;

    let isCartIncludedInView = true;
    const setCardIncludedFlag = flag => (isCartIncludedInView = flag);
    const getElementIfVisible = (elem, isCardIncluded = true) => {
      if (isElementVisibleOnDOM(elem)) {
        setCardIncludedFlag(isCardIncluded);
        return elem;
      }
      return false;
    };
    // TODO: maybe we need to do this per view? i.e: search-results / region results / registration...
    // determain which DOMNode to scroll to (passed from the child)
    let refToScroll =
      getElementIfVisible(this.confirmationRef, false) ||
      getElementIfVisible(this.registrationPaymentRef) ||
      getElementIfVisible(this.regionResultsRef) ||
      getElementIfVisible(this.searchResultsRef) ||
      getElementIfVisible(this.dealRatesGroupRef) ||
      getElementIfVisible(this.dealsResultsRef) ||
      getElementIfVisible(this.carouselRef) ||
      getElementIfVisible(this.roomboxRef) ||
      getElementIfVisible(this.selectedDealRef);

    if (refToScroll) {
      // const shouldScrollTop = !this.isElementTopIntoView(refToScroll);
      // if (!shouldScrollTop) return;

      let spacingFromTop = -260; // buffer (some spacing from top of searchbox)
      if (isMobileView) {
        spacingFromTop = isCartIncludedInView ? -200 : -100;
      }
      // scroll to the relevant DOMNode
      this._scrollToComponent(refToScroll, {
        align: "top",
        offset: spacingFromTop
      });
    }
  };

  scrollToRates = () => {
    this._scrollToComponent(this.ratesGroupRef, { align: "top", offset: -10 });
  };

  scrollToDealRates = () => {
    this._scrollToComponent(this.dealRatesGroupRef, {
      align: "top",
      offset: -150
    });
  };

  scrollToContactUsForm = () => {
    this._scrollToComponent(this.contactUsFormRef, {
      align: "top",
      offset: -10
    });
  };

  scrollToRegistrationForm = () => {
    this._scrollToComponent(this.registrationFormRef, {
      align: "top",
      offset: -85
    });
  };

  onRateSelection = () => {
    if (this.staticCartRef) {
      //***we no longer need this as the cart is bottom fixed on mobile***///
      // static cart (for mobile display)
      this._scrollToComponent(this.staticCartRef, {
        align: "top",
        offset: -30
      });
    } else if (this.fixedDisplayBarRef && !this.isFixedBarFullyVisible()) {
      // fixed / absolute cart (for desktop display)
      this._scrollToComponent(this.fixedDisplayBarRef, {
        align: "top",
        offset: -30
      });
    }
  };

  onSelectedPaxChange = () => {
    this.scrollToFirstImportantView();
  };

  isFixedBarFullyVisible = () => {
    return (
      this.fixedDisplayBarRef &&
      isElementInViewPort(this.fixedDisplayBarRef, 50)
    );
  };

  attachRef = refName => node => {
    /* dynamically attach ref to the instance,
    * this is a callback that the children will use.
    * for example, in SearchResults container: <div ref={this.props.handleSearchresultsRef}>...</div>
    */
    this[refName] = node;
  };

  /** creating ref callbacks and scroll callbacks for the search results container */
  createSearchResultsRefAndHandlers = () => ({
    handleCarouselRef: this.attachRef("carouselRef"),
    handleRoomboxRef: this.attachRef("roomboxRef"),
    handleRatesGroupRef: this.attachRef("ratesGroupRef"),
    handleContactUsFormRef: this.attachRef("contactUsFormRef"),
    handleRoomBoxHeaderRef: this.attachRef("roomBoxHeaderRef"),
    handleSearchresultsRef: this.attachRef("searchResultsRef"),
    handleRegistrationPaymentRef: this.attachRef("registrationPaymentRef"),
    onDataLoaded: this.onChildMount,
    onShowRatesClick: this.scrollToRates,
    onShowContactUsForm: this.scrollToContactUsForm,
    onRateSelection: this.onRateSelection
  });

  /** creating ref callbacks and scroll callbacks for the registrations container */
  createRegionResultsRefAndHandlers = () => ({
    handleRegionResultsRef: this.attachRef("regionResultsRef")
  });

  /** creating ref callbacks and scroll callbacks for the registrations container */
  createRegistrationPaymentRefAndHandlers = () => ({
    handleRegistrationPaymentRef: this.attachRef("registrationPaymentRef"),
    handleRegistrationFormRef: this.attachRef("registrationFormRef"),
    scrollToRegistrationForm: this.scrollToRegistrationForm
  });

  /** creating ref callbacks and scroll callbacks for the confirmation container */
  createConfirmationRefAndHandlers = () => ({
    handleConfirmationRef: this.attachRef("confirmationRef")
  });

  createGeneralHandlers = () => ({
    onLoad: this.scrollToFirstImportantView
  });

  /** Dina 13/01/19 creating ref callbacks and scroll callbacks for the deal results container */
  createDealResultsRefAndHandlers = () => ({
    handleDealRatesGroupRef: this.attachRef("dealRatesGroupRef"),
    handleDealsResultsRef: this.attachRef("dealsResultsRef"),
    onDealRatesClick: this.scrollToDealRates
  });

  render() {
    const { children } = this.props;

    const handlers = {
      generalHandlers: this.createGeneralHandlers(),
      searchResultsRefAndHandlers: this.createSearchResultsRefAndHandlers(),
      regionResultsRefAndHandlers: this.createRegionResultsRefAndHandlers(),
      createRegistrationPaymentRefAndHandlers: this.createRegistrationPaymentRefAndHandlers(),
      createConfirmationRefAndHandlers: this.createConfirmationRefAndHandlers(),
      dealResultsRefAndHandlers: this.createDealResultsRefAndHandlers()
    };

    return children(handlers);
  }
}

ScrollManager.propTypes = {
  isMobileView: PropTypes.bool,
  children: PropTypes.func
};

const mapStateToProps = store => ({
  isMobileView: store.isMobileView
});

export default withRouter(connect(mapStateToProps)(ScrollManager));



// WEBPACK FOOTER //
// ./src/containers/ScrollManager.js